import { Country } from './country';
import { User } from './user';

export class Organization {
  name: string;
  countries: Country[];
  notification_countries: Country[];
  seats: number;
}
